"use client";

import { Card } from "@/components/custom/card/card";

export function FormWrapper({
  beforeContent,
  children,
}: {
  beforeContent?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <>
      {beforeContent}

      <Card.MaxWidthWrapper>
        <Card>
          <Card.Content>{children}</Card.Content>
        </Card>
      </Card.MaxWidthWrapper>
    </>
  );
}
